import apiService from '@/utils/request';

const URIs = {
  info: '/v1/usuarios/usuario/perfil'
};

export function getUserInfo() {
  let urlStr = URIs.info;
  return apiService.get(urlStr);
}
